import Nullstack from 'nullstack';
export default function IconThreedCubeSphere({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-3d-cube-sphere",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 17.6l-2 -1.1v-2.5"
  }), "   ", Nullstack.element("path", {
    d: "M4 10v-2.5l2 -1.1"
  }), "   ", Nullstack.element("path", {
    d: "M10 4.1l2 -1.1l2 1.1"
  }), "   ", Nullstack.element("path", {
    d: "M18 6.4l2 1.1v2.5"
  }), "   ", Nullstack.element("path", {
    d: "M20 14v2.5l-2 1.12"
  }), "   ", Nullstack.element("path", {
    d: "M14 19.9l-2 1.1l-2 -1.1"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "12",
    x2: "14",
    y2: "10.9"
  }), "   ", Nullstack.element("line", {
    x1: "18",
    y1: "8.6",
    x2: "20",
    y2: "7.5"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "12",
    x2: "12",
    y2: "14.5"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "18.5",
    x2: "12",
    y2: "21"
  }), "   ", Nullstack.element("path", {
    d: "M12 12l-2 -1.12"
  }), "   ", Nullstack.element("line", {
    x1: "6",
    y1: "8.6",
    x2: "4",
    y2: "7.5"
  }), " ");
}